import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import { colorToken, useStyleProps } from '../utils';
import styles from './styles.module.css';
// Пердотвращает неправильное отображение для сторибука вариантов h1 и size caption и т.п.
const undescoreSeelectorVariants = ['s', 'm', 'l', 'overline', 'caption', 'caption_accent'];
/**
 * Компонент `<Typography />` используется для отображения текстовой информации.
 * @param {TypographyProps} props
 * @constructor
 */
export const Typography = /*#__PURE__*/forwardRef(function Typography({
  overrideStyles = true,
  children,
  variant,
  size,
  className,
  as = 'span',
  color,
  style,
  ...props
}, ref) {
  const styleProps = useStyleProps({
    color
  }, typographyStyleProps, style);
  const classNames = useMemo(() => {
    const actualVariant = undescoreSeelectorVariants.indexOf(variant) !== -1 ? `_${variant}` : variant;
    return clsx(styles.typography, styles[actualVariant], size && styles[size], overrideStyles && styles['override-style'], className);
  }, [className, variant, size, overrideStyles]);
  return /*#__PURE__*/React.createElement(as, {
    ...props,
    ...styleProps,
    className: classNames,
    ref
  }, children);
});
const typographyStyleProps = {
  color: ['color', colorToken]
};